<template>
  <div :style="{ backgroundColor: projectUXUIDesignWideData.backgroundColor }"
       class="customer-uxuidesign-div">
    <div class="customer-uxuidesign-textdiv">
      <h1 :style="{color: projectUXUIDesignWideData.titleColor}" class="customer-uxuidesign-title">
        {{ projectUXUIDesignWideData.title }}<h1 class="customer-designuxui-title">DESIGN</h1>
        <img  class="customer-uxuidesignmobile-imageabove" :src="projectUXUIDesignWideData.textAboveImage">
      </h1>
      <p class="customer-uxuidesign-text">{{ projectUXUIDesignWideData.text }}</p>
      <img class="customer-uxuidesignmobile-imageabove :src="projectUXUIDesignWideData.textUnderImage">
    </div>
    <div class="customer-uxuidesign-imagediv">
      <img class="customer-uxuidesign-imagenew" :src="images[imageIndex]">
      <div v-if="images.length > 1" class="customer-uxuidesign-button" @click="changeImage(index)" v-for="(image, index) in images" :id="index"
           :style="{color: index === imageIndex ? projectUXUIDesignWideData.colorNew : 'white'}">
        <img class="customer-uxuidesign-image" :src="projectUXUIDesignWideData.image" v-if="index === imageIndex">
        <h1 class="customer-uxuinumberdesign-text"> {{index + 1}} </h1>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'CustomerUXUIDesignWide',
    props: {
      projectUXUIDesignWideData: {
        backgroundColor: String,
        title: String,
        titleColor: String,
        textAboveImage: String,
        text: String,
        textUnderImage: String,
        images: Array,
        imagesMobile: Array,
        colorNew: String,
        image: String
      }
    },
    data() {
      return {
        images: this.projectUXUIDesignWideData.images,
        chosenimage: "",
        imageIndex: 0,
      }
    },
    methods:
      {
        changeImage: function (index) {
          console.log(this);
          this.imageIndex = index;
        }
      },
    created() {
      this.images = window.innerWidth > 600 ? this.projectUXUIDesignWideData.images : this.projectUXUIDesignWideData.imagesMobile
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../assets/scss/customeruxuidesignwide.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerUXUIDesignWide.vue